module.exports = require("mdast-util-heading-range");


//////////////////
// WEBPACK FOOTER
// external "mdast-util-heading-range"
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13 14